import { Action } from 'redux';
import { ConceptCategoryState, ConceptCategoryUnloadState } from '../states/ConceptCategoryState';
import { ConceptCategory } from '../../models/Entities/Contracts/ConceptCategory';

export default function ConceptCategoryReducer(
  state: ConceptCategoryState | undefined,
  action: Action
): ConceptCategoryState {
  const currentState = state ?? ConceptCategoryUnloadState;
  const a: any = action;

  switch (a.type) {
    // GET ALL
    case 'CONCEPT_CATEGORY_GET_ALL_REQUEST_ACTION':
      return {
        ...currentState,
        isLoadingAll: true,
        successLoadingAll: undefined,
        failOnLoadingAll: false,
        error: undefined
      };
    case 'CONCEPT_CATEGORY_GET_ALL_RECEIVE_ACTION':
      return {
        ...currentState,
        isLoadingAll: false,
        successLoadingAll: true,
        failOnLoadingAll: false,
        list: a.conceptCategories,
        error: undefined
      };
    case 'CONCEPT_CATEGORY_GET_ALL_FAIL_ACTION':
      return {
        ...currentState,
        isLoadingAll: false,
        successLoadingAll: false,
        failOnLoadingAll: true,
        error: a.error
      };

    // GET BY ID
    case 'CONCEPT_CATEGORY_GET_BY_ID_REQUEST_ACTION':
      return {
        ...currentState,
        isLoadingOne: true,
        successLoadingOne: undefined,
        failOnLoadingOne: false,
        error: undefined
      };
    case 'CONCEPT_CATEGORY_GET_BY_ID_RECEIVE_ACTION': {
      const existing = currentState.list.find((c: ConceptCategory) => c.id === a.conceptCategory.id);
      const updated = existing ? { ...existing, ...a.conceptCategory } : a.conceptCategory;
      return {
        ...currentState,
        isLoadingOne: false,
        successLoadingOne: true,
        failOnLoadingOne: false,
        selected: updated,
        list: existing
          ? currentState.list.map((c: ConceptCategory) => (c.id === updated.id ? updated : c))
          : [...currentState.list, updated],
        error: undefined
      };
    }
    case 'CONCEPT_CATEGORY_GET_BY_ID_FAIL_ACTION':
      return {
        ...currentState,
        isLoadingOne: false,
        successLoadingOne: false,
        failOnLoadingOne: true,
        error: a.error
      };

    // ADD
    case 'CONCEPT_CATEGORY_ADD_REQUEST_ACTION':
      return {
        ...currentState,
        isAddingNewOne: true,
        successAddingNewOne: undefined,
        failOnAddingNewOne: false,
        error: undefined
      };
    case 'CONCEPT_CATEGORY_ADD_RECEIVE_ACTION':
      return {
        ...currentState,
        isAddingNewOne: false,
        successAddingNewOne: true,
        failOnAddingNewOne: false,
        list: [...currentState.list, a.conceptCategory],
        error: undefined
      };
    case 'CONCEPT_CATEGORY_ADD_FAIL_ACTION':
      return {
        ...currentState,
        isAddingNewOne: false,
        successAddingNewOne: false,
        failOnAddingNewOne: true,
        error: a.error
      };

    // UPDATE
    case 'CONCEPT_CATEGORY_UPDATE_REQUEST_ACTION':
      return {
        ...currentState,
        isUpdatingOne: true,
        successUpdatingOne: undefined,
        failOnUpdatingOne: false,
        error: undefined
      };
    case 'CONCEPT_CATEGORY_UPDATE_RECEIVE_ACTION':
      return {
        ...currentState,
        isUpdatingOne: false,
        successUpdatingOne: true,
        failOnUpdatingOne: false,
        list: currentState.list.map((c: ConceptCategory) =>
          c.id === a.conceptCategory.id ? { ...c, ...a.conceptCategory } : c
        ),
        error: undefined
      };
    case 'CONCEPT_CATEGORY_UPDATE_FAIL_ACTION':
      return {
        ...currentState,
        isUpdatingOne: false,
        successUpdatingOne: false,
        failOnUpdatingOne: true,
        error: a.error
      };

    // DELETE
    case 'CONCEPT_CATEGORY_DELETE_REQUEST_ACTION':
      return {
        ...currentState,
        isDeletingOne: true,
        successDeletingOne: undefined,
        failOnDeletingOne: false,
        error: undefined
      };
    case 'CONCEPT_CATEGORY_DELETE_RECEIVE_ACTION':
      return {
        ...currentState,
        isDeletingOne: false,
        successDeletingOne: true,
        failOnDeletingOne: false,
        list: currentState.list.filter((c: ConceptCategory) => c.id !== a.conceptCategoryId),
        error: undefined
      };
    case 'CONCEPT_CATEGORY_DELETE_FAIL_ACTION':
      return {
        ...currentState,
        isDeletingOne: false,
        successDeletingOne: false,
        failOnDeletingOne: true,
        error: a.error
      };

    default:
      return currentState;
  }
}
